import { Component, Input } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ManageUsersDialogComponent } from "./manage-users-dialog.component";
import { ManageUsersEntityType } from "./manage-users-dialog-data";
import { AuthenticationService } from "../services/authentication.service";

@Component({
  selector: "app-manage-users",
  template: `
    <button
      *ngIf="authenticationService.canAssignRoles | async"
      mat-raised-button
      color="primary"
      (click)="openDialog()"
    >
      <mat-icon>group</mat-icon>
      {{ 'manageUsers' | translate }}
    </button>
  `,
})
export class ManageUsersComponent {
  @Input() entityType: ManageUsersEntityType;
  @Input() entityId: string | null;

  constructor(
    private dialog: MatDialog,
    public authenticationService: AuthenticationService,
  ) {}

  openDialog() {
    const config = new MatDialogConfig();
    config.data = { entityType: this.entityType, entityId: this.entityId };
    config.width = "65vw";
    config.maxWidth = "960px";
    config.maxHeight = "80vh";
    this.dialog.open(ManageUsersDialogComponent, config);
  }
}
